<div class="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-night via-gray-900 to-night">
  <div
    class="w-full max-w-md bg-night/80 backdrop-blur-sm border border-white/10 rounded-2xl p-8 shadow-2xl shadow-black/50">
    <div class="text-center mb-8">
      <h1
        class="text-3xl font-bold text-white mb-2 bg-gradient-to-r from-white via-neon to-white bg-clip-text text-transparent">
        {{ 'auth.login.title' | translate }}
      </h1>
      <p class="text-white/70 text-base">{{ 'auth.login.subtitle' | translate }}</p>
    </div>

    <form [formGroup]="loginForm">
      <div class="flex flex-col space-y-2">
        <k-input
          formControlName="email"
          [placeholder]="'auth.login.email_placeholder' | translate"
          type="email"
          [errorMessages]="emailErrorMessages"
          suffixIcon="email"
          [showClearButton]="true"></k-input>

        <k-input
          formControlName="password"
          [placeholder]="'auth.login.password_placeholder' | translate"
          type="password"
          [errorMessages]="passwordErrorMessages"></k-input>
      </div>

      <div class="mt-6">
        <k-button
          [fullWidth]="true"
          [isLoading]="userFacade.loading()"
          (click)="onSubmit()"
          [disabled]="loginForm.invalid">
          {{ 'auth.login.submit_button' | translate }}
        </k-button>
      </div>

      <div class="mt-4 text-right">
        <button
          type="button"
          class="text-sm text-neon hover:text-white transition-colors underline-offset-4 underline"
          (click)="navigateToResetPassword()">
          {{ 'auth.reset.forgot_link' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
